import { DiscoverClassifyHotWords } from 'shared/models';
import { atom } from 'jotai';
import { pendingQueue } from 'shared/utils/pending-queue';
import { safeAtomFamily } from 'shared/utils/safe-atom-family';

type DiscoverClassifyHotWordsStore = { [key: string]: DiscoverClassifyHotWords | undefined };

export const $DiscoverClassifyHotWordsStore = atom<DiscoverClassifyHotWordsStore>({});

export const $DiscoverClassifyHotWords = safeAtomFamily((keyword: string) => {
  const a = atom(
    (get) => {
      const data = get($DiscoverClassifyHotWordsStore)[keyword];
      if (!data) {
        // eslint-disable-next-line @typescript-eslint/no-throw-literal
        throw new Promise((resolve) => pendingQueue.push(resolve));
      }
      return data;
    },
    (get, set, input: DiscoverClassifyHotWords) => {
      const old = get($DiscoverClassifyHotWordsStore);
      set($DiscoverClassifyHotWordsStore, { ...old, [keyword]: input });
    },
  );

  a.debugLabel = `$DiscoverClassifyHotWords+${encodeURIComponent(keyword)}`;

  return a;
});
